import { render, staticRenderFns } from "./GpCampaign.vue?vue&type=template&id=567ea918&scoped=true&"
import script from "./GpCampaign.vue?vue&type=script&lang=js&"
export * from "./GpCampaign.vue?vue&type=script&lang=js&"
import style0 from "./GpCampaign.vue?vue&type=style&index=0&id=567ea918&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ea918",
  null
  
)

export default component.exports